import { Link } from "react-router-dom";
import { Mountain } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t bg-primary text-primary-foreground">
      <div className="container py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Mountain className="h-6 w-6 text-accent" />
              <span className="font-display text-lg font-bold">
                Soil<span className="text-accent">Connect</span> Pro
              </span>
            </Link>
            <p className="text-sm text-primary-foreground/60">
              The environmental materials marketplace for NY &amp; NJ. AI-powered compliance, trusted haulers, verified materials.
            </p>
          </div>
          <div>
            <h3 className="mb-3 font-display font-semibold text-accent text-base">Marketplace</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/60">
              <li><Link to="/marketplace" className="hover:text-accent">Browse Materials</Link></li>
              <li><Link to="/post-listing" className="hover:text-accent">Post a Listing</Link></li>
              <li><Link to="/marketplace?type=receiving" className="hover:text-accent">Receiving Sites</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="mb-3 font-display font-semibold text-accent text-base">Services</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/60">
              <li><Link to="/analysis" className="hover:text-accent">AI Environmental Analysis</Link></li>
              <li><Link to="/trucking" className="hover:text-accent">Trucking & Hauling</Link></li>
              <li><Link to="/analysis" className="hover:text-accent">Regulatory Compliance</Link></li>
              <li><Link to="/guides/clean-fill-vs-regular-dirt" className="hover:text-accent">Clean Fill vs. Regular Dirt</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="mb-3 font-display font-semibold text-accent text-base">Company</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/60">
              <li><Link to="/login" className="hover:text-accent">Log In</Link></li>
              <li><Link to="/register" className="hover:text-accent">Sign Up</Link></li>
              <li><Link to="/contact" className="hover:text-accent">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-primary-foreground/10 pt-8 text-center text-xs text-primary-foreground/80">
          © {new Date().getFullYear()} SoilConnect Pro. All rights reserved. Not affiliated with regulatory agencies.
        </div>
      </div>
    </footer>
  );
}
